import { urlHelpers } from 'conversional-api';
import isEmpty from 'lodash/isEmpty';
import { pick } from 'lodash';
export var BRANCH_SERVICE_SELECTION_FILTERS = {
    BOOKING_LINK_ID: 'bookingLinkId',
    BRANCHES: 'bookableBranches',
    SERVICE_TYPES: 'bookableServiceTypes',
    AGENTS: 'bookableAgents',
    PRODUCT_GROUPS: 'bookableProductGroups',
    BRANCH_SERVICES: 'bookableBranchServices',
    BRANCHES_FIRST: 'branchesFirst',
};
/**
 * Determines if the widget should open based on the URL parameters
 */
export var URL_PARAM_OPEN_WIDGET = urlHelpers.URL_PARAM_OPEN_WIDGET;
export function widgetShouldOpen(urlParams) {
    // In some cases it was not possible to get the query string parameters from window.location
    // This is probably due to the use of Vue
    // Instead the href string need s to be parsed manually
    var widgetShouldOpen = Boolean(URL_PARAM_OPEN_WIDGET in urlParams) ||
        Boolean('Onlineberatung' in urlParams) ||
        Boolean('onlineberatung' in urlParams);
    if (!widgetShouldOpen && window.location.href.indexOf(URL_PARAM_OPEN_WIDGET)) {
        urlParams[URL_PARAM_OPEN_WIDGET] = urlHelpers.parseHref(window.location.href)[URL_PARAM_OPEN_WIDGET];
    }
    return Boolean(urlParams[URL_PARAM_OPEN_WIDGET] || widgetShouldOpen);
}
/**
 * Function will read URL parameters that are needed in the queries for dynamic cnotent
 * This will extract the ?dynamic parameter as well as the nested &content=key:value,key2:value2
 */
export function extractDynamicContentParams() {
    var parameters = new URLSearchParams(window.location.search);
    if (!parameters.get('dynamic')) {
        return {};
    }
    var content = parameters.get('content');
    var contentParams = extractCommaSeparatedParams(content);
    return {
        dynamic: parameters.get('dynamic'),
        contentParams: contentParams,
    };
}
export var extractCommaSeparatedParams = function (urlPart) {
    var params = {};
    var decoded = decodeURIComponent(urlPart);
    if (urlPart && typeof urlPart === 'string') {
        decoded.split(',').map(function (pair) {
            var record = pair.split(':');
            var value = record[1] || null;
            if (typeof value === "string" && value.includes(";")) {
                // @ts-ignore
                value = value.split(";");
            }
            params[record[0]] = value || null;
        });
    }
    return params;
};
export var extractBranchServiceSelectionFilters = function (urlPart) {
    var params = extractCommaSeparatedParams(urlPart);
    if (isEmpty(params))
        return {};
    var picked = pick(params, Object.keys(BRANCH_SERVICE_SELECTION_FILTERS).map(function (key) { return BRANCH_SERVICE_SELECTION_FILTERS[key]; }));
    return Object.fromEntries(Object.entries(picked).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, Array.isArray(value) ? value : [value]];
    }));
};
